import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { useTheme } from "next-themes";

interface WordPopLogoProps {
  linkTo?: string | null;
  size?: "sm" | "md" | "lg";
  className?: string;
  onClick?: () => void;
}

const sizeClasses = {
  sm: "h-6 sm:h-7",
  md: "h-8",
  lg: "h-14 md:h-16"
};

export function WordPopLogo({ linkTo = "/", size = "md", className, onClick }: WordPopLogoProps) {
  const { resolvedTheme } = useTheme();
  
  // Use dark logo for dark theme, light logo for light theme (PNG format)
  const logoSrc = resolvedTheme === "dark" 
    ? "/assets/wordpop-logo-dark.png" 
    : "/assets/wordpop-logo-light.png";

  const logoContent = (
    <img 
      src={logoSrc} 
      alt="WordPop" 
      className={cn(sizeClasses[size], "w-auto")}
    />
  );

  const baseClasses = cn(
    "inline-flex items-center",
    className
  );

  if (linkTo === null) {
    return (
      <span className={baseClasses} onClick={onClick} data-wordpop-logo>
        {logoContent}
      </span>
    );
  }

  return (
    <Link 
      to={linkTo} 
      className={cn(baseClasses, "hover:opacity-80 transition-opacity")}
      onClick={onClick}
      data-wordpop-logo
      data-logo-link
    >
      {logoContent}
    </Link>
  );
}

// Backward compatibility alias
export const WormbleLogo = WordPopLogo;
